"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeroRightClassName = 'right-scroll-bar-position';
exports.fullWidthClassName = 'width-before-scroll-bar';
exports.noScrollbarsClassName = 'with-scroll-bars-hidden';
exports.removedBarSizeVariable = '--removed-body-scroll-bar-size';



//////////////////
// WEBPACK FOOTER
// ./~/react-remove-scroll-bar/dist/es5/constants.js
// module id = 138
// module chunks = 0